<template>
  <div class="contract-manager-selector">
    <CDropdown
      color="light"
      :toggler-text="selectedLabel"
    >
      <CDropdownItem
        v-for="cm in contractManagers"
        :key="cm.id"
        :active="cm.id === selectedId"
        @click="onSelect(cm.id)"
      >
        <div class="d-flex align-items-center justify-content-between w-100">
          <span>{{ cm.name }}</span>
          <CIcon
            v-if="cm.id === selectedId"
            name="cipCheck"
            size="sm"
            class="text-primary ml-2"
          />
        </div>
      </CDropdownItem>
    </CDropdown>
  </div>
</template>

<script>
export default {
  name: 'ContractManagerSelector',
  props: {
    contractManagers: {
      type: Array,
      required: true
    },
    selectedId: {
      type: Number,
      default: null
    }
  },
  computed: {
    selectedLabel() {
      const selected = this.contractManagers.find(cm => cm.id === this.selectedId)
      return selected ? selected.name : this.$pgettext('payout.selector', 'Seleziona...')
    }
  },
  methods: {
    onSelect(cmId) {
      if (cmId !== this.selectedId) {
        this.$emit('select', cmId)
      }
    }
  }
}
</script>